import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import ActionButton from "./formInputs/buttons/ActionButton.jsx";
import TranslationButtonGroup from "./translations/TranslationButtonGroup.jsx";

import { GlobalContext } from "./contextProvider/ContextProvider";
import { hasRole } from "../utils/isUser";
import { isUserDistrictAdmin, isUserSchoolAdmin, isUserTeacher, isUserPk12 } from "../utils/isUser.jsx";

import "../styles/Toolbar.scss";

const Toolbar = () => {
    const { state, dispatch } = useContext(GlobalContext);
    const { userDetails, isDistrictViewingSchool } = state || {};

    const [isDistrict, setIsDistrict] = useState(false);
    const [isGuardian, setIsGuardian] = useState(false);
    const [isSchoolAdmin, setIsSchoolAdmin] = useState(false);

    const getLocationName = () => {
        return userDetails?.userAttributeDto?.userAttributeMap?.CURRENT_PREDOMINANT_SCHOOL?.name || "";
    };

    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;

    const getLocation = () => {
        if (isDistrict) {
            return <span>District Admin</span>;
        }
        if (isUserPk12(userDetails)) {
            return <span>Director of Schools</span>;
        }
        if (isSchoolAdmin || isUserTeacher(userDetails)) {
            return <span>{getLocationName()}</span>;
        }
    };

    /* Determine if user is district admin or school admin */
    useEffect(() => {
        if (isUserDistrictAdmin(userDetails)) {
            setIsDistrict(true);
        }
        if (isUserSchoolAdmin(userDetails)) {
            setIsSchoolAdmin(true);
        }
        setIsGuardian(hasRole(userDetails, ["GUARDIAN"]));
    }, [userDetails]);

    // Determine if admin/PK12 is impersonating a teacher
    const isTeacherImpersonationView = pathname.includes("teacher-view");
    // Principals return to school overview; district/PK12 return to principal school home.
    const showOverviewBackButton = isUserSchoolAdmin(userDetails) && isTeacherImpersonationView;

    return (
        <div className="toolbar">
            <div className="tb-content-wrapper">
                <Link className="toolbar-link-home" to="/home">
                    Report Card
                </Link>{" "}
                <div className="divider"></div>
                {getLocation()}
            </div>
            {isGuardian ? (
                <TranslationButtonGroup />
            ) : (
                <ActionButton
                    className="ghost-button-reg"
                    label={showOverviewBackButton ? "Back to Report Card Overview" : "Home"}
                    onClick={() => {
                        if (showOverviewBackButton) {
                            navigate("/home/overview");
                        } else {
                            navigate("/home");
                            // Keep school context when district/PK12 drilled into a school
                            // so Home lands on the principal SchoolAdmin view, not district home.
                            const viewingSchool =
                                isDistrictViewingSchool || !!sessionStorage.getItem("viewedSchoolKey");
                            if (!viewingSchool) {
                                sessionStorage.removeItem("viewedSchoolKey");
                                dispatch({
                                    type: "IsDistrictViewingSchool",
                                    isDistrictViewingSchool: false
                                });
                            }
                        }
                    }}
                />
            )}
        </div>
    );
};

export default Toolbar;
